/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Count_Has_ImageInputs */

const vi_shop_home_count_has_image = /** @type {(inputs: Shop_Home_Count_Has_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`có ảnh`)
};

/**

* @param {Shop_Home_Count_Has_ImageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_count_has_image = /** @type {((inputs?: Shop_Home_Count_Has_ImageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Count_Has_ImageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_count_has_image(inputs)
});